import React from 'react'
import styled from 'styled-components'
import SearchBar from './SearchBar'
import ElementTree from './ElementTree'
//import FilterContainer from './FilterContainer'

const ContainerDiv = styled.div`
  width: 100%;
  height: 100%;
`

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: center;
  margin-top: 15px;
  justify-content: flex-start;
  padding-top: 10px;
  width: 100%;
`

const ElementTreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: center;
  margin-top: 15px;
  justify-content: flex-start;
  padding-top: 10px;
  width: 100%;
`

const SearchBarContainer = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  align-self: center;
`

class DataDirectory extends React.Component {
  render() {
    return (
      <ContainerDiv>
        <StyledDiv>
          <SearchBarContainer>
            <SearchBar />
          </SearchBarContainer>
          {/*
          <FilterContainer
            filters={['all', 'Reportz', 'Looker', 'Sheets']}
            updateSourceFilter={this.props.updateSourceFilter}
          />
          */}
        </StyledDiv>
        <ElementTreeContainer>
          <ElementTree />
        </ElementTreeContainer>
      </ContainerDiv>
    )
  }
}

export default DataDirectory
